import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from './scenes/GameIntro';

interface PhaserWaiterMemoryGameProps {
    onComplete: () => void;
}

interface PhaserWaiterMemoryGameState {
}

const gameConfig: GameConfig = {
    title: "Waiter Memory Game",
    version: "0.2",
    backgroundColor: "#000000",
};

class PhaserWaiterMemoryGame extends React.Component<PhaserWaiterMemoryGameProps, PhaserWaiterMemoryGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserWaiterMemoryGameProps) {
        super(props);
        bindAllOfThis(this, PhaserWaiterMemoryGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserWaiterMemoryGame;



// WEBPACK FOOTER //
// ./src/games/WaiterMemoryGame/Main.tsx